import type { EnPI } from '@/src/types/enpi.type'

/**
 * Checks if an effectiveness date falls within or before the EnPI's baseline timeframe.
 * The effectiveness date must be strictly after the EnPI's referenceDateTo.
 */
export const isEffectivenessDateInvalidForEnpi = (
  effectivenessDate: string | undefined,
  enpiId: number | undefined,
  enpis: EnPI[] | undefined
): boolean => {
  if (!enpiId || !effectivenessDate || !enpis) {
    return false
  }

  const linkedEnpi = enpis.find(enpi => enpi.id === enpiId)
  if (!linkedEnpi?.referenceDateTo) {
    return false
  }

  const effectivenessDay = new Date(effectivenessDate)
  effectivenessDay.setHours(0, 0, 0, 0)
  const referenceEndDay = new Date(linkedEnpi.referenceDateTo)
  referenceEndDay.setHours(0, 0, 0, 0)

  return effectivenessDay.getTime() <= referenceEndDay.getTime()
}
